import React from "react";

const ResizedPage = () => {
  return (
    <div className="resized-page">
      <p className="resized-page__text">Window is resized</p>
      <p className="resized-page__text">You should refresh page!</p>
    </div>
  );
};

export default ResizedPage;
